import {
  Text
} from '@fozito/common-ui';
import { get } from 'lodash';
import styled from 'styled-components';
import EBT_icon from './icons/EBT.svg';
import ePay_icon from './icons/EPay.svg';
import add_price_icon from './icons/add-price.svg';
import calc_icon from './icons/calculator.svg';
import cash_icon from './icons/cash.svg';
import clear_icon from './icons/clear.svg';
import credit_card_icon from './icons/credit-card.svg';
import discount_icon from './icons/discount.svg';
import gift_card_icon from './icons/gift-card.svg';
import loyalty_point_icon from './icons/loyalty-point.svg';
import multi_card_icon from './icons/multi-card.svg';
import multi_pay_icon from './icons/multi-pay.svg';
import save_ticket_icon from './icons/save.svg';
import sell_gift_icon from './icons/sell-gift.svg';
import voided_icon from './icons/voided.svg';
import weight_icon from './icons/weight.svg';

export enum ActionType {
  CALCULATOR = 'CALCULATOR',
  VOID = 'VOID',
  CLEAR_TICKET = 'CLEAR_TICKET',
  DISCOUNT = 'DISCOUNT',
  SELL_GIFT = 'SELL_GIFT',
  ADD_PRICE = 'ADD_PRICE',
  SAVE_TICKET = 'SAVE_TICKET',
  WEIGHT = 'WEIGHT',

  CASH = 'CASH',
  CARD = 'CARD',
  MULTI_PAY = 'MULTI_PAY',
  MULTI_CARDS = 'MULTI_CARDS',
  E_PAYS = 'E_PAYS',
  GIFT_CARD = 'GIFT_CARD',
  EBT = 'EBT',
  EBT_FOOD = 'EBT_FOOD',
  LOYALTY = 'LOYALTY',
}

const configs = {
  [ActionType.CALCULATOR]: {
    title: 'Calculator',
    icon: calc_icon,
  },
  [ActionType.VOID]: {
    title: 'Void',
    icon: voided_icon,
  },
  [ActionType.CLEAR_TICKET]: {
    title: 'Clear Ticket',
    icon: clear_icon,
  },
  [ActionType.DISCOUNT]: {
    title: 'Discount',
    icon: discount_icon,
  },
  [ActionType.SELL_GIFT]: {
    title: 'Sell Gift',
    icon: sell_gift_icon,
  },
  [ActionType.ADD_PRICE]: {
    title: 'Add Price',
    icon: add_price_icon,
  },
  [ActionType.SAVE_TICKET]: {
    title: 'Save Ticket',
    icon: save_ticket_icon,
  },
  [ActionType.CASH]: {
    title: 'Cash',
    icon: cash_icon,
  },
  [ActionType.CARD]: {
    title: 'Card',
    icon: credit_card_icon,
  },
  [ActionType.MULTI_PAY]: {
    title: 'Multi Pay',
    icon: multi_pay_icon,
  },
  [ActionType.MULTI_CARDS]: {
    title: 'Multi Cards',
    icon: multi_card_icon,
  },
  [ActionType.E_PAYS]: {
    title: 'EPays',
    icon: ePay_icon,
  },
  [ActionType.GIFT_CARD]: {
    title: 'Gift Card',
    icon: gift_card_icon,
  },
  [ActionType.LOYALTY]: {
    title: 'POINTS',
    icon: loyalty_point_icon,
  },
  [ActionType.EBT]: {
    title: 'EBT',
    icon: EBT_icon,
  },
  [ActionType.EBT_FOOD]: {
    title: 'EBT Food',
    icon: EBT_icon,
  },
  [ActionType.WEIGHT]: {
    title: 'Weigh',
    icon: weight_icon,
  },
};

type Props = {
  type: keyof typeof ActionType;
  htmlType?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  disabled?: boolean;
};
const CashierActionButton = ({ type, htmlType = 'button', onClick, disabled }: Props) => {
  const config = get(configs, [type]);
  if (!config) return null;

  return (
    <StyledButton disabled={disabled} onClick={onClick} type={htmlType}>
      <img src={config.icon} alt={config.title} style={{ width: 'auto', height: 80 }} />
      <Text color_text_5 text_center content_content_3_16_semibold >
        {config.title}
      </Text>
    </StyledButton>
  );
};

export default CashierActionButton;

const StyledButton = styled.button`
  display: flex;
  min-width: 120px;
  height: 124px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  background: #fcfcfd;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4),
    0px 4px 8px -3px rgba(45, 35, 66, 0.3),
    0px -6px 0px 0px rgba(28, 52, 43, 0.1) inset;

  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

  &:disabled {
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      transition: none;
    }
  }
`;
